var Afghanistan = "Afghanistan";
var Albania = "Albanien";
var Algeria = "Algerien";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Antarktis";
var Argentina = "Argentinien";
var Armenia = "Armenien";
var Aruba = "Aruba";
var Australia = "Australien";
var Austria = "Österreich";
var Azerbaijan = "Aserbaidschan";
var Bahamas = "Bahamas";
var Bahrain = "Bahrain";
var Bangladesh = "Bangladesch";
var Barbados = "Barbados";
var Belarus = "Weißrussland";
var Belgium = "Belgien";
var Belize = "Belize";
var Benin = "Benin";
var Bermuda = "Bermuda";
var Bhutan = "Bhutan";
var Bolivia = "Bolivien";
var Botswana = "Botsuana";
var Brazil = "Brasilien";
var Bulgaria = "Bulgarien";
var Burundi = "Burundi";
var Cambodia = "Kambodscha";
var Cameroon = "Kamerun";
var Canada = "Kanada";
var Chad = "Tschad";
var Chile = "Chile";
var China = "China";
var Colombia = "Kolumbien";
var Comoros = "Komoren";
var Congo = "Kongo";
var Croatia = "Kroatien";
var Cuba = "Kuba";
var Cyprus = "Zypern";
var Denmark = "Dänemark";
var Djibouti = "Dschibuti";
var Dominica = "Dominica";
var Ecuador = "Ecuador";
var Egypt = "Ägypten";
var Eritrea = "Eritrea";
var Estonia = "Estland";
var Ethiopia = "Äthiopien";
var Fiji = "Fidschi";
var Finland = "Finnland";
var France = "Frankreich";
var Gabon = "Gabun";
var Gambia = "Gambia";
var Georgia = "Georgien";
var Germany = "Deutschland";
var Ghana = "Ghana";
var Gibraltar = "Gibraltar";
var Greece = "Griechenland";
var Greenland = "Grönland";
var Grenada = "Grenada";
var Guadeloupe = "Guadeloupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernsey";
var Guinea = "Guinea";
var Guyana = "Guyana";
var Haiti = "Haiti";
var Honduras = "Honduras";
var Hungary = "Ungarn";
var Iceland = "Island";
var India = "Indien";
var Indonesia = "Indonesien";
var Iraq = "Irak";
var Ireland = "Irland";
var Israel = "Israel";
var Italy = "Italien";
var Jamaica = "Jamaica";
var Japan = "Japan";
var Jersey = "Jersey";
var Jordan = "Jordanien";
var Kazakhstan = "Kasachstan";
var Kenya = "Kenia";
var Kiribati = "Kiribati";
var Kuwait = "Kuwait";
var Kyrgyzstan = "Kirgisistan";
var Latvia = "Lettland";
var Lebanon = "Libanon";
var Lesotho = "Lesotho";
var Liberia = "Liberia";
var Libya = "Libysch-Arabische Dschamahirija";
var Liechtenstein = "Liechtenstein";
var Lithuania = "Litauen";
var Luxembourg = "Luxemburg";
var Macao = "Macao";
var Madagascar = "Madagaskar";
var Malawi = "Malawi";
var Malaysia = "Malaysia";
var Maldives = "Malediven";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinique";
var Mauritania = "Mauretanien";
var Mauritius = "Mauritius";
var Mayotte = "Mayotte";
var Mexico = "Mexiko";
var Monaco = "Monaco";
var Mongolia = "Mongolei";
var Montenegro = "Montenegro";
var Montserrat = "Montserrat";
var Morocco = "Marokko";
var Mozambique = "Mosambik";
var Myanmar = "Myanmar";
var Namibia = "Namibia";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Niederlande";
var Nicaragua = "Nicaragua";
var Niger = "Niger";
var Nigeria = "Nigeria";
var Niue = "Niue";
var Norway = "Norwegen";
var Oman = "Oman";
var Pakistan = "Pakistan";
var Palau = "Palau";
var Panama = "Panama";
var Paraguay = "Paraguay";
var Peru = "Peru";
var Philippines = "Philippinen";
var Pitcairn = "Pitcairn";
var Poland = "Polen";
var Portugal = "Portugal";
var Qatar = "Katar";
var Romania = "Rumänien";
var Rwanda = "Ruanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Serbien";
var Seychelles = "Seychellen";
var Singapore = "Singapur";
var Slovakia = "Slowakei";
var Slovenia = "Slowenien";
var Somalia = "Somalia";
var Spain = "Spanien";
var Sudan = "Sudan";
var Suriname = "Suriname";
var Swaziland = "Swasiland";
var Sweden = "Schweden";
var Switzerland = "Schweiz";
var Taiwan = "Taiwan";
var Tajikistan = "Tadschikistan";
var Thailand = "Thailand";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunesien";
var Turkey = "Türkei";
var Turkmenistan = "Turkmenistan";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ukraine";
var Uruguay = "Uruguay";
var Uzbekistan = "Usbekistan";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Jemen";
var Zambia = "Sambia";
var Zimbabwe = "Simbabwe";
var countries = {
	"Country or region": "Land oder Region",
	"United States": "USA",
	Afghanistan: Afghanistan,
	"Åland Islands": "Åland",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Amerikanisch-Samoa",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua und Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosnien und Herzegowina",
	Botswana: Botswana,
	"Bouvet Island": "Bouvetinsel",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Britisches Territorium im Indischen Ozean",
	"Brunei Darussalam": "Brunei Darussalam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Kap Verde",
	"Cayman Islands": "Kaimaninseln",
	"Central African Republic": "Zentralafrikanische Republik",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Weihnachtsinsel",
	"Cocos (Keeling) Islands": "Kokosinseln (Keelinginseln)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Kongo, Demokratische Republik",
	"Cook Islands": "Cookinseln",
	"Costa Rica": "Costa Rica",
	"Côte d'Ivoire": "Côte d'Ivoire (Elfenbeinküste)",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "Tschechien",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "Dominikanische Republik",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Äquatorialguinea",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Falklandinseln (Malwinen)",
	"Faroe Islands": "Faröer",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Französisch-Guyana",
	"French Polynesia": "Französisch-Polynesien",
	"French Southern Territories": "Französische Süd- und Antarktisgebiete",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinea-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Heard und McDonaldinseln",
	"Holy See (Vatican City State)": "Heiliger Stuhl (Staat Vatikanstadt)",
	Honduras: Honduras,
	"Hong Kong": "Hongkong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Iran, Islamische Republik",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Isle of Man",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Korea, Demokratische Volksrepublik",
	"Korea, Republic of": "Korea, Republik",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Volksdemokratische Republik Laos",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Nordmazedonien",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Marshallinseln",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Mikronesien, Föderierte Staaten von",
	"Moldova, Republic of": "Moldau, Republik",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Niederländische Antillen",
	"New Caledonia": "Neukaledonien",
	"New Zealand": "Neuseeland",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Norfolkinsel",
	"Northern Mariana Islands": "Nördliche Marianen",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Palästinensische Gebiete, Besetzte",
	Panama: Panama,
	"Papua New Guinea": "Papua-Neuguinea",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Puerto Rico",
	Qatar: Qatar,
	"Réunion": "La Réunion",
	Romania: Romania,
	"Russian Federation": "Russische Föderation",
	Rwanda: Rwanda,
	"Saint Helena": "St. Helena",
	"Saint Kitts and Nevis": "St. Kitts und Nevis",
	"Saint Lucia": "St. Lucia",
	"Saint Pierre and Miquelon": "Saint-Pierre und Miquelon",
	"Saint Vincent and The Grenadines": "St. Vincent und die Grenadinen",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "São Tomé und Príncipe",
	"Saudi Arabia": "Saudi-Arabien",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leone",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Salomoninseln",
	Somalia: Somalia,
	"South Africa": "Südafrika",
	"South Georgia and The South Sandwich Islands": "Südgeorgien und die Südlichen Sandwichinseln",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard und Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "Syrische Arabische Republik",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Tansania, Vereinigte Republik",
	Thailand: Thailand,
	"Timor-Leste": "Osttimor",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad und Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Turks- und Caicosinseln",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Vereinigte Arabische Emirate",
	"United Kingdom": "Vereinigtes Königreich",
	"United States Minor Outlying Islands": "Kleinere Amerikanische Überseeinseln",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Vietnam",
	"Virgin Islands, British": "Jungferninseln, Britisch",
	"Virgin Islands, U.S.": "Jungferninseln, Amerikanisch",
	"Wallis and Futuna": "Wallis und Futuna",
	"Western Sahara": "Westsahara",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
